// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3Tcdz","dragIcon":"Choice_dragIcon__39Pim","left":"Choice_left__2DkiU","input":"Choice_input__3-9jq"};